import { render } from "./BaselinesBlock.vue?vue&type=template&id=379e3392&scoped=true"
import script from "./BaselinesBlock.vue?vue&type=script&lang=js"
export * from "./BaselinesBlock.vue?vue&type=script&lang=js"

import "./BaselinesBlock.vue?vue&type=style&index=0&id=379e3392&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379e3392"]])

export default __exports__